import React, { useState } from 'react';
import { db } from '../AppointmentComp/firebase'; // Make sure the path is correct
import { collection, addDoc, serverTimestamp } from 'firebase/firestore'; // Import necessary methods
import emailjs from 'emailjs-com'; // Import EmailJS
import "./corporateprogram.css";

function CorporateProgram() {
  const [formData, setFormData] = useState({
    name: '',
    organizationName: '',
    address: '',
    province: '',
    district: '',
    city: '',
    postalCode: '',
    contactNo: '',
    email: '',
    note: '',
    expectedParticipants: '',
    assumption: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Save form data to Firebase Firestore
      await addDoc(collection(db, "corporateprogram"), {
        ...formData,
        createdAt: serverTimestamp(), // Automatically adds timestamp on creation
      });
  
      // Send email using EmailJS
      const emailTemplateParams = {
        to_name: "Admin",
        from_name: formData.name,
        organizationName: formData.organizationName,
        address: formData.address,
        province: formData.province,
        district: formData.district,
        contactNo: formData.contactNo,
        email: formData.email,
        note: formData.note,
        expectedParticipants: formData.expectedParticipants,
      };
  
      emailjs.send('service_tqyzrz1', 'template_tdjov4l', emailTemplateParams, 'V7GeEtMQ7Wi0eUrRM')
        .then(response => {
          console.log('Email sent successfully', response);
        })
        .catch(err => {
          console.error('Error sending email', err);
        });
  
      alert("Your request has been submitted successfully!");
      setFormData({
        name: '',
        organizationName: '',
        address: '',
        province: '',
        district: '',
        city: '',
        postalCode: '',
        contactNo: '',
        email: '',
        note: '',
        expectedParticipants: '',
        assumption: false,
      });
    } catch (error) {
      console.error("Error adding document: ", error);
      alert("An error occurred while submitting your request.");
    }
  };


  return (
    <>
      {/* Banner Image */}
      <div className="corporate-banner">
        <img src="/orthoptic.jpg" alt="corporate Banner" className="corporate-banner-image" />
      </div>

      <div className="corporate-program-container">
        <div className="corporate-program-header">
          <div className="corporate-description">
            <h1>Organize an Eye Camp for Your Organization</h1>
            <p>
              We offer corporate programs for Eye Care all around the country. 
              Our dedicated eye care professionals provide high-quality screenings, consultations, and guidance to ensure the well-being of your employees. 
              This program aims to raise awareness about eye health and provide immediate support through our team of specialists.
            </p>
          </div>
          <div className="corporate-image">
            <img src="eyecamp1.png" alt="Eye Camp" />
          </div>
        </div>

        <div className="corporate-form-container">
          <h2>Request Eye Camp for Your Organization</h2>
          <form onSubmit={handleSubmit} className="corporate-form">
            {/* Form Fields */}
            <div className="form-group-corporate">
              <label htmlFor="name">Your Name:</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group-corporate">
              <label htmlFor="organizationName">Organization Name:</label>
              <input
                type="text"
                id="organizationName"
                name="organizationName"
                value={formData.organizationName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group-corporate">
              <label htmlFor="address">Address:</label>
              <textarea
                id="address"
                name="address"
                value={formData.address}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group-corporate">
              <label htmlFor="province">Province:</label>
              <select
              id="province"
              name="province"
              value={formData.province}
              onChange={handleChange}
              required
            >
              <option value="">Select Province</option>
              <option value="Western">Western</option>
              <option value="Central">Central</option>
              <option value="Southern">Southern</option>
              <option value="Eastern">Eastern</option>
              <option value="Northern">Northern</option>
              <option value="Uva">Uva</option>
              <option value="North Western">North Western</option>
              <option value="North Central">North Central</option>
              <option value="Sabaragamuwa">Sabaragamuwa</option>
            </select>
            </div>

            <div className="form-group-corporate">
              <label htmlFor="district">District:</label>
              <select
              id="district"
              name="district"
              value={formData.district}
              onChange={handleChange}
              required
            >
              <option value="">Select District</option>
              <option value="Colombo">Colombo</option>
              <option value="Gampaha">Gampaha</option>
              <option value="Kandy">Kandy</option>
              <option value="Matara">Matara</option>
              <option value="Jaffna">Jaffna</option>
              <option value="Galle">Galle</option>
              <option value="Kurunegala">Kurunegala</option>
              <option value="Anuradhapura">Anuradhapura</option>
              <option value="Kegalle">Kegalle</option>
              <option value="Badulla">Badulla</option>
              <option value="Ratnapura">Ratnapura</option>
              <option value="Trincomalee">Trincomalee</option>
              <option value="Vavuniya">Vavuniya</option>
              <option value="Batticaloa">Batticaloa</option>
              <option value="Mullaitivu">Mullaitivu</option>
              <option value="Puttalam">Puttalam</option>
              <option value="Nuwara Eliya">Nuwara Eliya</option>
              <option value="Moneragala">Moneragala</option>
              <option value="Matale">Matale</option>
              <option value="Kilinochchi">Kilinochchi</option>
              <option value="Hambantota">Hambantota</option>
              <option value="Polonnaruwa">Polonnaruwa</option>
              <option value="Mannar">Mannar</option>
              <option value="Jaffna">Jaffna</option>
              <option value="Mullaitivu">Mullaitivu</option>
              <option value="Ampara">Ampara</option>
              <option value="Kilinocchi">Kilinocchi</option>
            </select>
            </div>

            <div className="form-group-corporate">
              <label htmlFor="city">City:</label>
              <select
              id="city"
              name="city"
              value={formData.city}
              onChange={handleChange}
              required
            >
              <option value="">Select City</option>
              
                    {/* Colombo District */}
                    <option value="Colombo">Colombo</option>
                    <option value="Dehiwala">Dehiwala</option>
                    <option value="Moratuwa">Moratuwa</option>
                    <option value="Mount Lavinia">Mount Lavinia</option>
                    <option value="Kelaniya">Kelaniya</option>

                    {/* Gampaha District */}
                    <option value="Gampaha">Gampaha</option>
                    <option value="Negombo">Negombo</option>
                    <option value="Ja-Ela">Ja-Ela</option>
                    <option value="Wattala">Wattala</option>

                    {/* Kandy District */}
                    <option value="Kandy">Kandy</option>
                    <option value="Peradeniya">Peradeniya</option>
                    <option value="Katugastota">Katugastota</option>

                    {/* Matara District */}
                    <option value="Matara">Matara</option>
                    <option value="Tangalle">Tangalle</option>
                    <option value="Weligama">Weligama</option>

                    {/* Jaffna District */}
                    <option value="Jaffna">Jaffna</option>
                    <option value="Chavakachcheri">Chavakachcheri</option>
                    <option value="Point Pedro">Point Pedro</option>

                    {/* Galle District */}
                    <option value="Galle">Galle</option>
                    <option value="Hikkaduwa">Hikkaduwa</option>
                    <option value="Unawatuna">Unawatuna</option>

                    {/* Kurunegala District */}
                    <option value="Kurunegala">Kurunegala</option>
                    <option value="Puttalam">Puttalam</option>

                    {/* Anuradhapura District */}
                    <option value="Anuradhapura">Anuradhapura</option>
                    <option value="Mihintale">Mihintale</option>

                    {/* Kegalle District */}
                    <option value="Kegalle">Kegalle</option>
                    <option value="Mawanella">Mawanella</option>

                    {/* Badulla District */}
                    <option value="Badulla">Badulla</option>
                    <option value="Bandarawela">Bandarawela</option>

                    {/* Ratnapura District */}
                    <option value="Ratnapura">Ratnapura</option>
                    <option value="Balangoda">Balangoda</option>

                    {/* Trincomalee District */}
                    <option value="Trincomalee">Trincomalee</option>
                    <option value="Nilaveli">Nilaveli</option>

                    {/* Vavuniya District */}
                    <option value="Vavuniya">Vavuniya</option>

                    {/* Batticaloa District */}
                    <option value="Batticaloa">Batticaloa</option>
                    <option value="Kalmunai">Kalmunai</option>

                    {/* Mullaitivu District */}
                    <option value="Mullaitivu">Mullaitivu</option>

                    {/* Puttalam District */}
                    <option value="Puttalam">Puttalam</option>

                    {/* Nuwara Eliya District */}
                    <option value="Nuwara Eliya">Nuwara Eliya</option>

                    {/* Moneragala District */}
                    <option value="Moneragala">Moneragala</option>

                    {/* Matale District */}
                    <option value="Matale">Matale</option>

                    {/* Kilinochchi District */}
                    <option value="Kilinochchi">Kilinochchi</option>

                    {/* Hambantota District */}
                    <option value="Hambantota">Hambantota</option>
                    <option value="Tissamaharama">Tissamaharama</option>

                    {/* Polonnaruwa District */}
                    <option value="Polonnaruwa">Polonnaruwa</option>

                    {/* Mannar District */}
                    <option value="Mannar">Mannar</option>

                    {/* Ampara District */}
                    <option value="Ampara">Ampara</option>

                    {/* Kilinochchi District */}
                    <option value="Kilinochchi">Kilinochchi</option>
                  </select>
            </div>

            <div className="form-group-corporate">
              <label htmlFor="postalCode">Postal Code:</label>
              <input
                type="text"
                id="postalCode"
                name="postalCode"
                value={formData.postalCode}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group-corporate">
              <label htmlFor="contactNo">Contact Number:</label>
              <input
                type="tel"
                id="contactNo"
                name="contactNo"
                value={formData.contactNo}
                onChange={handleChange}
                required
                pattern="^[0-9]{10}$"
                title="Please enter a 10-digit phone number"
                maxLength="10"  // This limits the input length to 10 characters
              />
            </div>


            <div className="form-group-corporate">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group-corporate">
              <label htmlFor="note">Additional Notes:</label>
              <textarea
                id="note"
                name="note"
                value={formData.note}
                onChange={handleChange}
              />
            </div>

            <div className="form-group-corporate">
              <label htmlFor="expectedParticipants">Expected Participants:</label>
              <input
                type="number"
                id="expectedParticipants"
                name="expectedParticipants"
                value={formData.expectedParticipants}
                onChange={handleChange}
                required
              />
            </div>

            <button type="submit" className="corporate-submit-button">Submit</button>
          </form>
        </div>
      </div>
    </>
  );
}

export default CorporateProgram;
